import React from 'react';
import {Box, Stack} from '@mui/material';

/** Tab label with a small count pill (shared by both coverage modals). */
const TabLabelWithCount = ({label, count, selected}) => (
    <Stack direction="row" spacing={0.75} alignItems="center" component="span">
        <span>{label}</span>
        <Box
            component="span"
            sx={{
                px: 0.75,
                py: 0.125,
                minWidth: 18,
                borderRadius: 10,
                bgcolor: selected ? 'primary.main' : 'action.selected',
                color: selected ? 'primary.contrastText' : 'text.secondary',
                fontSize: '0.65rem',
                fontWeight: 700,
                lineHeight: 1.5,
                fontFamily: 'Roboto Mono, monospace',
                textAlign: 'center',
            }}
        >
            {count}
        </Box>
    </Stack>
);

export default TabLabelWithCount;
